import React from 'react';
import propTypes from 'prop-types';

import { Button, Input, ButtonLayout } from '../../components';

import { useTranslate } from '../Internationalization';

import messages from './messages';

const NewsletterForm = ({ size = 'small' }) => {
  const t = useTranslate(messages);

  return (
    <form id="newsletter-form" action="/">
      <div id="form-message" className="text-color-white" />
      <Input
        size={size}
        type="email"
        id="newsletter-email"
        className="border border-white"
        placeholder={t('emailPlaceholder')}
      />
      <ButtonLayout direction="vertical" className="mb-none">
        <Button
          id="submit-newsletter-button"
          size={size}
          padded
          className="border border-white"
          color="white"
          submit
        >
          {t('buttonLabel')}
        </Button>
      </ButtonLayout>
    </form>
  );
};

NewsletterForm.propTypes = {
  size: propTypes.oneOf(['small', 'large']),
};

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/modules/NewsletterForm/index.js